'use strict';

export const defaultState = () => {
    return {};
};

export const state = () => defaultState();

export const getters = {};

export const mutations = {};

export const actions = {
    index(ctx, { search = '' } = {}) {
        const params = {
            q: search
        };

        return this.$axios.$get('/medication-categories', {
            params
        });
    },

    show(ctx, { id, params: { preview = false, uuid = null } = {} }) {
        const params = {};

        if (preview) {
            params.preview = true;
        }

        if (uuid) {
            params.uuid = uuid;
        }

        return this.$axios.$get(`/medication-categories/${id}`, { params });
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
